(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fultons-brands-portfolio"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-fultons-brands]').forEach(root => {
    if (root.dataset.searchReady) return;
    root.dataset.searchReady = 'true';
    const input = root.querySelector('[data-brand-search]');
    const clear = root.querySelector('[data-brand-search-clear]');
    const entries = Array.from(root.querySelectorAll('[data-brand-entry]'));
    const groups = Array.from(root.querySelectorAll('[data-brand-group]'));
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const filter = () => {
      const term = normalize(input.value);
      let count = 0;
      entries.forEach(entry => { entry.hidden = !normalize(entry.dataset.brandName).includes(term); if (!entry.hidden) count++; });
      groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-brand-entry]')).some(entry => !entry.hidden); });
      root.querySelector('[data-brand-count]').textContent = count + ' ' + (count === 1 ? root.dataset.countOne : root.dataset.countOther);
      root.querySelector('[data-brands-empty]').hidden = count !== 0;
      clear.hidden = !input.value;
    };
    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
    clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
    filter();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fultons-catalogue"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-catalogue-filters]').forEach(function(form) {
  if (form.dataset.ready) return;
  form.dataset.ready = 'true';
  form.dataset.autoApply = 'true';
  form.addEventListener('change', function(){ form.requestSubmit(); });
  form.addEventListener('submit', function(event) {
    event.preventDefault();
    var tags = [form.querySelector('[data-type]')?.value, form.querySelector('[data-brand]')?.value].filter(Boolean);
    var path = form.dataset.collectionUrl + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '');
    var url = new URL(path, window.location.origin);
    if (form.dataset.themePreview === 'true') url.searchParams.set('preview_theme_id', form.dataset.themeId);
    url.searchParams.set('sort_by', form.querySelector('[data-sort]').value);
    window.FultonsCollectionPriceRange?.applyToUrl(url, form);
    url.hash = 'LivingProducts';
    window.location.assign(url.href);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fultons-clearance-catalogue"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.exdisplay').forEach(function(section) {
  var filters = section.querySelector('.exdisplay__filters');
  var cards = Array.from(section.querySelectorAll('.exdisplay__card'));
  if (filters) {
    filters.hidden = false;
    var results = filters.querySelector('[data-exdisplay-results]');
    filters.querySelectorAll('[data-exdisplay-filter]').forEach(function(button) {
      var category = button.dataset.exdisplayFilter;
      if (category !== 'all' && !cards.some(function(card) { return card.dataset.exdisplayCategory === category; })) button.hidden = true;
      button.addEventListener('click', function() {
        var count = 0;
        cards.forEach(function(card) {
          card.hidden = category !== 'all' && card.dataset.exdisplayCategory !== category;
          if (!card.hidden) count++;
        });
        filters.querySelectorAll('[data-exdisplay-filter]').forEach(function(filter) { filter.setAttribute('aria-pressed', String(filter === button)); });
        var exactLabel = section.querySelector('[data-exdisplay-result-label="' + count + '"]');
        var countTemplate = section.querySelector('[data-exdisplay-results-template]');
        results.textContent = exactLabel ? exactLabel.textContent : countTemplate.textContent.replace(/123(?:,|\s)?456(?:,|\s)?789/g, String(count));
      });
    });
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fultons-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const fillProductEnquiry = () => {
    const product = new URL(location.href).searchParams.get('product')?.trim();
    const message = document.querySelector('#FultonsGeneralEnquiry textarea[name="contact[body]"]');
    if (!product || !message || message.value.trim()) return;
    message.value = "I'd like to enquire about:\n\n" + product.slice(0, 8000);
  };

  const initEnquiryFeedback = () => {
    const form = document.querySelector('#FultonsGeneralEnquiry');
    const feedback = form?.querySelector('[data-contact-feedback]');
    if (!form || !feedback || form.dataset.feedbackReady) return;
    form.dataset.feedbackReady = 'true';
    const message = feedback.querySelector('[data-contact-feedback-text]');
    const email = feedback.querySelector('[data-contact-email]');
    const fields = Array.from(form.querySelectorAll('input[required], textarea[required]'));
    let timer;
    const show = (state, text) => {
      feedback.dataset.state = state;
      message.textContent = text;
      feedback.hidden = false;
      email.hidden = state !== 'waiting';
    };
    const reportInvalid = () => {
      const invalid = fields.filter(field => !field.validity.valid);
      if (!invalid.length) return false;
      clearTimeout(timer);
      const names = invalid.map(field => field.labels?.[0]?.textContent.replace(/\s*\*\s*$/, '').trim()).filter(Boolean);
      show('invalid', feedback.dataset.invalid + ' ' + names.join(', ') + '.');
      return true;
    };
    const showSending = () => {
      if (reportInvalid() || feedback.dataset.state === 'sending') return;
      show('sending', feedback.dataset.sending);
      timer = setTimeout(() => {
        show('waiting', feedback.dataset.waiting);
      }, 20000);
    };
    form.addEventListener('invalid', reportInvalid, true);
    form.querySelector('button[type="submit"]').addEventListener('click', showSending, true);
    form.addEventListener('submit', showSending, true);
    form.addEventListener('input', () => {
      if (feedback.dataset.state === 'invalid') feedback.hidden = true;
    });
    window.addEventListener('pagehide', () => clearTimeout(timer));
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      clearTimeout(timer);
      feedback.hidden = true;
      feedback.dataset.state = '';
    });
    const result = form.querySelector('[data-contact-result]');
    if (result) {
      result.focus();
      result.scrollIntoView({ block: 'center' });
    }
  };
  const init = () => {
    fillProductEnquiry();
    initEnquiryFeedback();
    const finance = document.querySelector('[data-finance-enquiry]');
    if (finance && !finance.dataset.enquiryReady) {
      finance.dataset.enquiryReady = 'true';
      finance.addEventListener('click', () => {
        const message = document.querySelector('#FultonsGeneralEnquiry textarea[name="contact[body]"]');
        if (message && !message.value.trim()) message.value = finance.dataset.enquiryMessage;
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fultons-coverings"] && !Shopify.designMode) return;
  try {
    
(function(scope){
  'use strict';
  const round=n=>Math.round((n+Number.EPSILON)*100)/100;
  const retail=(data,n)=>round(n*(data.retailMultiplier||1));
  function estimate(data,input){
    const p=Object.hasOwn(data.products,input.product)?data.products[input.product]:null;
    if(!p) return {error:'product'};
    const g=Object.hasOwn(p.groups,input.group)?p.groups[input.group]:null, c=Object.hasOwn(p.controls,input.control)?p.controls[input.control]:null;
    if(!g||!c) return {error:'choice'};
    const w=Number(input.width),d=Number(input.drop),q=Number(input.quantity);
    if(!String(input.width).trim()||!String(input.drop).trim()||!Number.isFinite(w)||!Number.isFinite(d)||w<=0||d<=0) return {error:'dimensions'};
    if(!Number.isInteger(q)||q<1||q>30) return {error:'quantity'};
    if(w<c.minWidth||w>c.maxWidth||d<c.minDrop||d>c.maxDrop||(c.maxArea&&w*d/1e6>c.maxArea)) return {error:'limits',limits:c};
    if(input.product==='twist'&&d>=w*4) return {error:'ratio'};
    const wi=g.widths.findIndex(x=>x>=w),di=g.rows.findIndex(x=>x[0]>=d);
    if(wi<0||di<0) return {error:'table'};
    const base=g.rows[di][1][wi];
    if(!Number.isFinite(base)||base<=0) return {error:'unverified'};
    const sellingBase=retail(data,base),controlPrice=retail(data,c.price),unit=round(sellingBase+controlPrice);
    return {product:input.product,group:input.group,control:input.control,width:w,drop:d,quantity:q,room:String(input.room||'').slice(0,80),base:sellingBase,controlPrice,unit,total:round(unit*q),charger:retail(data,c.charger||0),bandWidth:g.widths[wi],bandDrop:g.rows[di][0],page:g.page};
  }
  function project(data,items,options={}){
    const checked=items.map(i=>estimate(data,i));
    if(checked.some(i=>i.error))return {error:'invalid_project'};
    if(!checked.length)return {items:[],subtotal:0,charger:0,controller:0,gateway:0,total:0};
    const power=checked.some(i=>!!data.products[i.product].controls[i.control].powered);
    const subtotal=checked.reduce((s,i)=>s+i.total,0),charger=Math.max(...checked.map(i=>i.charger));
    const controllerKey=Object.hasOwn(data.accessories.controllers,options.controller)?options.controller:'pebble';
    const controller=power?retail(data,data.accessories.controllers[controllerKey].price):0;
    const controllerLabel=power?data.accessories.controllers[controllerKey].label:'';
    const gateway=power&&options.gateway?retail(data,data.accessories.gateway):0;
    return {items:checked,subtotal:round(subtotal),charger,controller,controllerKey,controllerLabel,gateway,total:round(subtotal+charger+controller+gateway),power};
  }
  const api={estimate,project,retail};if(typeof module!=='undefined'&&module.exports)module.exports=api;else scope.FultonsPricing=api;
})(typeof window==='undefined'?globalThis:window);

(function(){
 'use strict';
 const root=document.getElementById('fw-root');if(!root)return;
 const data=window.FultonsPriceData,engine=window.FultonsPricing;if(!data||!engine)return;
 let dict={};try{dict=JSON.parse(root.querySelector('[data-fw-translations]')?.textContent||'{}');}catch(e){}
 const t=s=>dict[s]||s, money=n=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:0,maximumFractionDigits:0}).format(n);
 const el=id=>root.querySelector('#fw-'+id), safe=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const line=(label,value)=>'<div><dt>'+safe(label)+'</dt><dd>'+safe(value)+'</dd></div>';
 root.querySelectorAll('[data-example]').forEach(card=>{
  const [product,group,control]=card.dataset.example.split('|'),p=engine.project(data,[{product,group,control,width:1000,drop:1200,quantity:1}],{});
  if(p.error)return;
  card.querySelector('[data-example-price]').textContent=money(p.total);
  card.querySelector('[data-example-detail]').textContent=t('Group')+' '+group+' · '+t(data.products[product].controls[control].label)+(p.charger?' · '+t('includes one Pebble remote and one shared charger'):'');
 });
 const enquiry=el('enquiry');
 if(enquiry&&root.dataset.preview==='true')enquiry.addEventListener('submit',e=>{e.preventDefault();el('form-status').textContent=t('Preview only — your enquiry has not been sent.');});
 const form=el('calculator-form');if(!form)return;
 const ids=['product','group','control','width','drop','quantity','room'],fields=Object.fromEntries(ids.map(id=>[id,el(id)]));
 let items=[],editing=-1,result=null,total=null;
 const pickers={};
 const svg=body=>'<svg viewBox="0 0 64 64" width="40" height="40" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'+body+'</svg>';
 function blindDrawing(product,topDown=false,control=''){
  const top=topDown?25:11,bottom=49;
  let body='<path d="M8 6h46v52H8z" stroke="#a7afa2"/><path d="M8 7h46v5H8z" fill="#dce2d6"/>';
  if(topDown)body+='<path d="M12 12v13m38-13v13"/>';
  if(product==='roller')body+='<path d="M10 12h42v34H10z" fill="#e8ece3"/><path d="M10 45h42"/>'+(control==='power'?'':'<path d="M56 14v29q4 5 4 0V14"/>');
  else if(product==='wood'){
   for(let y=14;y<49;y+=7)body+='<path d="M10 '+y+'h42l-2 4H8z" fill="#ded5c7"/>';
   body+='<path d="M19 12v40m24-40v40" stroke="#8b8173"/>';
  }else if(product==='twist'){
   body+='<path d="M10 12h42v38H10z" fill="#f8f9f6"/>';
   for(let y=13;y<47;y+=10)body+='<path d="M10 '+y+'h42v5H10z" fill="#bfc8b7" stroke="none"/>';
  }else if(product==='silhouette'||product==='sonnette'){
   body+='<path d="M10 12h42v39H10z" fill="#f2f4ef" stroke="#a7afa2"/>';
   for(let y=14;y<47;y+=9)body+=product==='sonnette'?'<path d="M11 '+y+'q20 7 40 0v6q-20 7-40 0z" fill="#dce2d6"/>':'<path d="M11 '+y+'q20 8 40 0m-40 3q20 8 40 0"/>';
  }else{
   body+='<path d="M10 '+top+'h42v'+(bottom-top)+'H10z" fill="#e8ece3"/>';
   for(let y=top+3;y<bottom-2;y+=5)body+='<path d="M11 '+y+'h40" stroke="#8c9784"/>';
   if(product==='duette')for(let y=top+2;y<bottom-4;y+=6)body+='<path d="M50 '+y+'l5 3-5 3-3-3z" fill="#f7f8f5"/>';
  }
  if(topDown)body+='<path d="M10 25h42v3H10z" fill="#c0cbb6"/><path d="M58 23v19m-3-16 3-3 3 3m-6 13 3 3 3-3"/>';
  return svg(body);
 }
 function controlDrawing(control){
  if(control.includes('tdbu'))return blindDrawing(fields.product.value,true);
  if(control==='lite')return svg('<path d="M8 8h48v24H8z" fill="#e8ece3"/><path d="M8 14h48M8 20h48M8 26h48M8 32h48M23 57l-6-9q-2-5 2-6l7 6V32q0-5 4-5t4 5v10l6-3q4-2 7 1l5 5v12M30 17v7m-3-3 3 3 3-3"/>');
  if(control==='smart')return svg('<path d="M31 5v20m-7 0h14v25q-7 8-14 0z" fill="#e8ece3"/><path d="M26 29h10m-10 4h10m-10 4h10M43 32v20m-3-3 3 3 3-3"/>');
  if(control==='power')return svg('<rect x="19" y="7" width="27" height="50" rx="13" fill="#e8ece3"/><circle cx="32.5" cy="30" r="8"/><path d="m30 18 3-3 3 3m-6 24 3 3 3-3m-3-27v4M11 22q-7 10 0 20M7 18q-10 14 0 28"/>');
  if(control==='cord')return svg('<path d="M8 9h48v6H8z" fill="#e8ece3"/><path d="M23 15v35m17-35v30m-18 5h2l2 7h-6zm17-5h2l2 7h-6z"/>');
  let body='<path d="M13 10h38v5H13z" fill="#e8ece3"/><path d="M32 15v30q0 11 10 11t10-11V15" stroke="#a7afa2"/>';
  for(let y=20;y<50;y+=7)body+='<circle cx="32" cy="'+y+'" r="2.4" fill="#e8ece3"/><circle cx="52" cy="'+y+'" r="2.4" fill="#e8ece3"/>';
  body+='<circle cx="36" cy="54" r="2.4"/><circle cx="44" cy="56" r="2.4"/><circle cx="50" cy="52" r="2.4"/>';
  return svg(body);
 }
 function enhanceSelect(select,kind){
  const label=select.previousElementSibling,wrapper=document.createElement('div'),button=document.createElement('button'),list=document.createElement('div');
  wrapper.className='fw-picture-select';button.className='fw-picture-trigger';button.type='button';button.id=select.id+'-button';button.setAttribute('role','combobox');button.setAttribute('aria-haspopup','listbox');button.setAttribute('aria-expanded','false');button.setAttribute('aria-controls',select.id+'-list');button.setAttribute('aria-labelledby',label.id+' '+select.id+'-value');
  if(select.getAttribute('aria-describedby'))button.setAttribute('aria-describedby',select.getAttribute('aria-describedby'));
  list.id=select.id+'-list';list.className='fw-picture-list';list.setAttribute('role','listbox');list.setAttribute('aria-labelledby',label.id);list.hidden=true;
  select.after(wrapper);wrapper.append(button,list);let active=0,search='',searchTimer;
  const drawing=value=>kind==='product'?blindDrawing(value):controlDrawing(value);
  const close=()=>{list.hidden=true;button.setAttribute('aria-expanded','false');button.removeAttribute('aria-activedescendant');};
  function highlight(index){
   active=Math.max(0,Math.min(index,list.children.length-1));
   [...list.children].forEach((option,i)=>option.dataset.active=String(i===active));
   const option=list.children[active];if(option){button.setAttribute('aria-activedescendant',option.id);option.scrollIntoView({block:'nearest'});}
  }
  function sync(){
   const selected=select.options[select.selectedIndex];if(!selected)return;
   button.innerHTML=drawing(selected.value)+'<span id="'+select.id+'-value">'+safe(selected.textContent)+'</span><span class="fw-select-chevron" aria-hidden="true"></span>';
   list.innerHTML=[...select.options].map((option,i)=>'<div class="fw-picture-option" id="'+select.id+'-option-'+i+'" role="option" aria-selected="'+String(option.selected)+'" data-value="'+safe(option.value)+'">'+drawing(option.value)+'<span>'+safe(option.textContent)+'</span><span class="fw-option-check" aria-hidden="true">'+(option.selected?'✓':'')+'</span></div>').join('');
   active=select.selectedIndex;if(!list.hidden)highlight(active);
  }
  const open=()=>{Object.values(pickers).forEach(p=>p.close());sync();list.hidden=false;button.setAttribute('aria-expanded','true');highlight(select.selectedIndex);};
  const choose=index=>{select.selectedIndex=index;close();select.dispatchEvent(new Event('change',{bubbles:true}));sync();button.focus();};
  button.addEventListener('click',()=>list.hidden?open():close());
  list.addEventListener('mousedown',event=>event.preventDefault());
  list.addEventListener('click',event=>{const option=event.target.closest('[role="option"]');if(option)choose([...list.children].indexOf(option));});
  button.addEventListener('keydown',event=>{
   const key=event.key;
   if(key==='Tab'){close();return;}
   if(key==='Escape'){if(!list.hidden){event.preventDefault();close();}return;}
   if(['ArrowDown','ArrowUp','Home','End','Enter',' '].includes(key)){
    event.preventDefault();
    if(list.hidden){open();if(key==='Home')highlight(0);if(key==='End')highlight(list.children.length-1);return;}
    if(key==='Enter'||key===' '){choose(active);return;}
    highlight(key==='Home'?0:key==='End'?list.children.length-1:active+(key==='ArrowDown'?1:-1));return;
   }
   if(key.length===1&&!event.ctrlKey&&!event.metaKey&&!event.altKey){
    event.preventDefault();if(list.hidden)open();clearTimeout(searchTimer);search+=key.toLocaleLowerCase();searchTimer=setTimeout(()=>search='',700);
    const index=[...select.options].findIndex(option=>option.textContent.toLocaleLowerCase().startsWith(search));if(index>=0)highlight(index);
   }
  });
  wrapper.addEventListener('focusout',event=>{if(!wrapper.contains(event.relatedTarget))close();});
  document.addEventListener('pointerdown',event=>{if(!wrapper.contains(event.target))close();});
  sync();select.hidden=true;label.htmlFor=button.id;return {sync,close};
 }

 const storageKey='fultons-soft-project-v1';
 let savedOptions={};
 try{const stored=JSON.parse(localStorage.getItem(storageKey)||'null');if(stored&&(stored.version===data.version||stored.version==='fultons-luxaflex-2026-09-27-v3')&&Array.isArray(stored.items)){items=stored.items.slice(0,50).filter(i=>i&&typeof i==='object'&&!engine.estimate(data,i).error).map(i=>engine.estimate(data,i));savedOptions=stored.options||{};}}catch(e){}
 const populate=(select,choices)=>{select.replaceChildren(...(Array.isArray(choices)?choices:Object.entries(choices)).map(([value,label])=>{const option=document.createElement('option');option.value=value;option.textContent=t(label);return option;}));};
 populate(fields.product,Object.fromEntries(Object.entries(data.products).map(([k,v])=>[k,v.name])));
 function choices(){
  const p=data.products[fields.product.value];
  populate(fields.group,p.groupOrder.map(k=>[k,t('Group')+' '+k]));
  populate(fields.control,Object.fromEntries(Object.entries(p.controls).map(([k,v])=>[k,v.label])));
  el('range-help').textContent=t(p.description);
 }
 choices();
 const params=new URLSearchParams(location.search);
 if(Object.hasOwn(data.products,params.get('range'))){fields.product.value=params.get('range');choices();}
 for(const name of ['group','control'])if([...fields[name].options].some(o=>o.value===params.get(name)))fields[name].value=params.get(name);
 for(const name of ['width','drop'])if(params.has(name)&&Number.isFinite(Number(params.get(name)))&&Number(params.get(name))>0)fields[name].value=params.get(name);
 const read=()=>Object.fromEntries(ids.map(id=>[id,fields[id].value]));
 const errors={product:t('Choose a blind range.'),choice:t('Choose a valid price group and control.'),dimensions:t('Enter a positive width and drop in millimetres.'),quantity:t('Enter a whole number of blinds from 1 to 30.'),limits:t('This size needs a specialist quotation for the chosen control. Please send us your measurements below.'),ratio:t('This window is too tall for its width in this range. Please ask our team for a quotation.'),table:t('This size is outside the published price table for this group. Please ask our team for a quotation.'),unverified:t('We cannot verify the supplier price for this combination. Please ask our team for a quotation.')};
 let projectImages={};try{projectImages=JSON.parse(root.querySelector('[data-fw-project-images]')?.textContent||'{}');}catch(e){}
 function renderSelectionImage(){
  const product=fields.product.value,control=fields.control.value,p=data.products[product];if(!p)return;
  const panel=el('project-image'),key=control.includes('tdbu')&&projectImages[product+'-tdbu']?product+'-tdbu':product,photo=projectImages[key];
  panel.dataset.range=product;panel.dataset.opening=control;
  el('project-image-title').textContent=t(p.name)+' · Luxaflex';
  el('project-image-control').textContent=t(p.controls[control]?.label||'');
  const fallback=()=>{panel.innerHTML=blindDrawing(product,control.includes('tdbu'),control);panel.removeAttribute('data-image-key');};
  if(!photo){fallback();return;}
  if(panel.dataset.imageKey===key){const current=panel.querySelector('img');if(current){current.onerror=fallback;if(current.complete&&!current.naturalWidth)fallback();}return;}
  panel.dataset.imageKey=key;
  const image=document.createElement('img');image.alt=photo.alt;image.width=photo.width;image.height=photo.height;image.loading='lazy';image.decoding='async';
  image.sizes='(max-width: 700px) calc(100vw - 80px), 420px';
  image.onerror=()=>{if(panel.contains(image))fallback();};
  image.srcset=[320,480,600,840].filter(w=>w<=photo.width).map(w=>photo.url+'&width='+w+' '+w+'w').join(', ');
  image.src=photo.url+'&width='+Math.min(600,photo.width);
  panel.replaceChildren(image);
 }
 function recalculate(){
  renderSelectionImage();
  Object.values(pickers).forEach(p=>p.sync());
  result=engine.estimate(data,read());el('result').hidden=!!result.error;el('error').hidden=!result.error;el('add').disabled=!!result.error;
  if(result.error){el('error').textContent=errors[result.error]||errors.choice;return;}
  el('price').textContent=money(result.total);
  el('price-details').innerHTML='<dl class="fw-breakdown">'+line(t('Blind guide price, each'),money(result.base))+line(t('Opening style & control, each'),result.controlPrice?money(result.controlPrice):t('Included'))+line(t('Quantity'),result.quantity)+'</dl><p class="fw-help">'+safe(t('Price band')+': '+result.bandWidth+' × '+result.bandDrop+' mm. '+t('Prices include VAT.'))+'</p>';
 }
 fields.product.addEventListener('change',()=>{choices();recalculate();});
 form.addEventListener('input',e=>{if(e.target!==fields.product)recalculate();});
 form.addEventListener('change',recalculate);
 function options(){return {controller:el('controller').value,gateway:el('gateway').checked};}
 function summary(){
  if(!total||!items.length)return '';
  return [t('Fultons · Luxaflex guide estimate'),new Date().toLocaleDateString('en-GB'),...total.items.map((i,n)=>`${n+1}. ${i.room||t('Window')+' '+(n+1)} — ${data.products[i.product].name}, ${t('Group')} ${i.group}, ${t(data.products[i.product].controls[i.control].label)}\n${i.width} × ${i.drop} mm; ${t('quantity')} ${i.quantity}; ${money(i.total)}`),t('Blinds subtotal')+': '+money(total.subtotal),...(total.charger?[t('One shared charger')+': '+money(total.charger)]:[]),...(total.controller?[t('Required control')+' — '+t(total.controllerLabel)+': '+money(total.controller)]:[]),...(total.gateway?[t('One PowerView Gateway')+': '+money(total.gateway)]:[]),t('Product guide total including VAT')+': '+money(total.total),t('Initial measuring visit and fitting fees: quoted separately using your installation address and number of blinds. Includes travel; fees are agreed before booking.'),t('Guide prices only. Fultons confirms fabric, finished dimensions, controls, availability, initial callout, fitting and travel before you order.'),data.version].join('\n\n');
 }
 function persist(){try{localStorage.setItem(storageKey,JSON.stringify({version:data.version,items,options:options()}));}catch(e){el('calc-status').textContent=t('Your browser could not save this project. Use Save estimate to keep a copy.');}}
 function renderProject(){
  total=engine.project(data,items,options());if(total.error){items=[];total=engine.project(data,[],{});}
  el('project-items').innerHTML=items.length?items.map((i,n)=>'<article class="fw-project-item"><strong>'+safe(i.room||t('Window')+' '+(n+1))+'</strong><p>'+safe(t(data.products[i.product].name)+' · '+t('Group')+' '+i.group)+'</p><p>'+safe(i.width+' × '+i.drop+' mm · '+t('quantity')+' '+i.quantity+' · '+money(i.total))+'</p><p>'+safe(t(data.products[i.product].controls[i.control].label))+'</p><div class="fw-item-actions"><button class="fw-link" type="button" data-edit="'+n+'" aria-label="'+safe(t('Edit')+' '+(i.room||t('Window')+' '+(n+1)))+'">'+safe(t('Edit'))+'</button><button class="fw-link" type="button" data-remove="'+n+'" aria-label="'+safe(t('Remove')+' '+(i.room||t('Window')+' '+(n+1)))+'">'+safe(t('Remove'))+'</button></div></article>').join(''):'<p class="fw-note">'+safe(t('Add your first window to see the complete guide total.'))+'</p>';
  el('power-options').hidden=!total.power;
  if(!total.power)el('gateway').checked=false;
  el('project-actions').hidden=!items.length;
  el('project-total').innerHTML=items.length?'<dl class="fw-breakdown">'+line(t('Blinds subtotal'),money(total.subtotal))+(total.charger?line(t('One shared charger'),money(total.charger)):'')+(total.controller?line(t('Required control')+' · '+t(total.controllerLabel),money(total.controller)):'')+(total.gateway?line(t('One PowerView Gateway'),money(total.gateway)):'')+'</dl><div class="fw-total"><p class="fw-note">'+safe(t('Product guide total · includes VAT'))+'</p><strong>'+money(total.total)+'</strong><p class="fw-help">'+safe(t('Initial measurement callout, fitting and travel are additional. We confirm the complete quotation before you order.'))+'</p></div>':'';
  const count=el('blind-count');if(count){count.readOnly=!!items.length;count.value=items.length?items.reduce((sum,item)=>sum+item.quantity,0):'';}
  el('enquiry-estimate-label').hidden=!items.length;el('enquiry-estimate').value=summary();persist();
 }
 populate(el('controller'),Object.entries(data.accessories.controllers).map(([key,c])=>[key,t(c.label)+' · '+money(engine.retail(data,c.price))]));
 if(Object.hasOwn(data.accessories.controllers,savedOptions.controller))el('controller').value=savedOptions.controller;
 el('gateway').checked=!!savedOptions.gateway;el('gateway-label').textContent=t('Add one PowerView Gateway')+' · '+money(engine.retail(data,data.accessories.gateway));
 form.addEventListener('submit',e=>{e.preventDefault();recalculate();if(result.error)return;if(editing<0&&items.length>=50){el('calc-status').textContent=t('For more than 50 windows, please contact our team.');return;}if(editing>=0)items[editing]=result;else items.push(result);editing=-1;el('add').textContent=t('Add window to project');renderProject();el('calc-status').textContent=t('Window saved to your project. Change the details to add another.');});
 el('project-items').addEventListener('click',e=>{
  const edit=e.target.closest('[data-edit]'),remove=e.target.closest('[data-remove]');
  if(edit){editing=Number(edit.dataset.edit);const item=items[editing];fields.product.value=item.product;choices();ids.forEach(id=>{fields[id].value=item[id]??'';});el('add').textContent=t('Save window changes');recalculate();fields.room.focus();form.scrollIntoView({block:'start'});el('calc-status').textContent=t('Editing this window. Save your changes to update the project.');}
  if(remove){const idx=Number(remove.dataset.remove);items.splice(idx,1);editing=-1;el('add').textContent=t('Add window to project');renderProject();el('calc-status').textContent=t('Window removed.');fields.room.focus();}
 });
 for(const id of ['controller','gateway'])el(id).addEventListener('change',renderProject);
 el('save').addEventListener('click',()=>{const blob=new Blob([summary()],{type:'text/plain;charset=utf-8'}),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='Fultons-Luxaflex-estimate.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);});
 el('print').addEventListener('click',()=>window.print());
 el('discuss').addEventListener('click',()=>{el('enquiry-estimate').value=summary();const select=enquiry.querySelector('select[name="contact[Project type]"]');if(select)select.selectedIndex=1;});
 pickers.product=enhanceSelect(fields.product,'product');
 pickers.control=enhanceSelect(fields.control,'control');
 recalculate();renderProject();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fultons-enquiry-confirmation"]) return;
  try {
    
(() => {
  const focusConfirmation = () => {
    const confirmation = document.getElementById('EnquiryConfirmation');
    if (confirmation) confirmation.focus({ preventScroll: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusConfirmation, { once: true });
  else focusConfirmation();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fultons-members"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-members-preview]').forEach(root=>{
  const rail=root.querySelector('.fm-gallery-rail'), dots=[...root.querySelectorAll('[data-members-slide]')];
  if(!rail)return;
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>{
    const slide=rail.children[index];
    rail.scrollTo({left:slide.offsetLeft-rail.children[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  }));
  rail.addEventListener('scroll',()=>{
    const step=(rail.children[0]?.getBoundingClientRect().width||0)+12;
    const selected=Math.max(0,Math.min(dots.length-1,Math.round(rail.scrollLeft/step)));
    dots.forEach((dot,index)=>index===selected?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current'));
  },{passive:true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fultons-service-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initServiceForms = () => {
    document.querySelectorAll('.fultons-service-form form').forEach(form => {
      const feedback = form.querySelector('[data-service-feedback]');
      if (!feedback || form.dataset.feedbackReady) return;
      form.dataset.feedbackReady = 'true';
      const message = feedback.querySelector('[data-service-feedback-text]');
      const email = feedback.querySelector('[data-service-email]');
      const fields = Array.from(form.querySelectorAll('.service-form-fields input, .service-form-fields select, .service-form-fields textarea'));
      const label = field => field.labels?.[0]?.textContent.replace(/\s*\*\s*$/, '').trim() || field.name;
      let timer;
      const show = (state, text) => {
        feedback.dataset.state = state;
        message.textContent = text;
        feedback.hidden = false;
        email.hidden = state !== 'waiting';
      };
      const reportInvalid = () => {
        const invalid = fields.filter(field => field.willValidate && !field.validity.valid);
        if (!invalid.length) return false;
        clearTimeout(timer);
        show('invalid', feedback.dataset.invalid + ' ' + invalid.map(label).join(', ') + '.');
        return true;
      };
      const showSending = () => {
        if (reportInvalid() || feedback.dataset.state === 'sending') return;
        show('sending', feedback.dataset.sending);
        timer = setTimeout(() => {
          show('waiting', feedback.dataset.waiting);
        }, 20000);
      };
      form.addEventListener('invalid', reportInvalid, true);
      form.querySelector('button[type="submit"]').addEventListener('click', showSending, true);
      form.addEventListener('submit', showSending, true);
      const clearInvalid = () => {
        if (feedback.dataset.state === 'invalid') feedback.hidden = true;
      };
      form.addEventListener('input', clearInvalid);
      form.addEventListener('change', clearInvalid);
      window.addEventListener('pagehide', () => clearTimeout(timer));
      window.addEventListener('pageshow', event => {
        if (!event.persisted) return;
        clearTimeout(timer);
        feedback.hidden = true;
        feedback.dataset.state = '';
      });
      const result = form.querySelector('[data-service-result]');
      if (result) {
        result.focus();
        result.scrollIntoView({ block: 'center' });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initServiceForms, { once: true });
  else initServiceForms();
  document.addEventListener('shopify:section:load', initServiceForms);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
